import axios from 'axios';

const {
    VUE_APP_API,
    VUE_APP_TFCC_API,
    VUE_APP_API_BANNERS,
    VUE_APP_API_COACH,
    VUE_APP_API_COMMITTEE,
    VUE_APP_API_FIXTURES,
    VUE_APP_API_NEWS,
    VUE_APP_API_PLAYER,
    VUE_APP_API_TRAINING,
    VUE_APP_API_EVENTS,
    VUE_APP_API_GALLERY,
    VUE_APP_API_EMAIL
} = process.env;

let no_cache = Math.floor(Math.random() * 10000)

const fetchBanners = async () => {
    try{
        const res =  await axios
        .get(`${VUE_APP_TFCC_API}${VUE_APP_API_BANNERS}?rand=${no_cache}`)
        if(res){
            return res.data.records
        }else{
            return []
        }
    }catch(e){
        return []
    }
    
};

const fetchCoaches = async () => {
    try{
        const res = await axios
        .get(`${VUE_APP_TFCC_API}${VUE_APP_API_COACH}?rand=${no_cache}`)
        if(res){
            return res.data.records
        }else{
            return []
        }
    }catch(e){
        return []
    }
    
};

const fetchCommitteeMembers = async () => {
    try{
        const res = await axios
        .get(`${VUE_APP_TFCC_API}${VUE_APP_API_COMMITTEE}?rand=${no_cache}`)
        if(res){
            return res.data.records
        }else{
            return []
        }
    }catch(e){
        return []
    }
    
};

const fetchFixtures = async () => {
    try{
        const res = await axios
        .get(`${VUE_APP_TFCC_API}${VUE_APP_API_FIXTURES}?rand=${no_cache}`)
        if(res){
            return res.data.records
        }else{
            return []
        }
    }catch(e){
        return []
    }
    
};

const fetchNews = async () => {
    try{
        const res = await axios.get(`${VUE_APP_TFCC_API}${VUE_APP_API_NEWS}?rand=${no_cache}`)
        if(res){
            return res.data.records
        }else{
            return []
        }
    }catch(e){
        return []
    }
   
};

const fetchNewsByID = async (id) => {
    try{
        const res = await axios
        .get(`${VUE_APP_TFCC_API}${VUE_APP_API_NEWS}/${id}?rand=${no_cache}`)
       if(res){
            return res.data.record
        }else{
            return {}
        }
    }catch(e){
        return {}
    }

};

const fetchPlayers = async () => {
    try{
       const res =  await axios
        .get(`${VUE_APP_TFCC_API}${VUE_APP_API_PLAYER}?rand=${no_cache}`)
        if(res){
            return res.data.records
        }else{
            return []
        }
    }catch(e){
        return []
    }
    
};

const fetchTraining = async () => {
    try{
        const res = await axios
        .get(`${VUE_APP_TFCC_API}${VUE_APP_API_TRAINING}?rand=${no_cache}`)
        if(res){
            return res.data.records
        }else{
            return []
        }
    }catch(e){
        return []
    }
    
};

const fetchEvents = async () => {
    try{
   const res = await axios
        .get(`${VUE_APP_TFCC_API}${VUE_APP_API_EVENTS}?rand=${no_cache}`)
       if(res){
            return res.data.records
        }else{
            return []
        }
    }catch(e){
        return []
    }
    
};

const fetchGallery = async () => {
    const res = await axios
        .get(`${VUE_APP_TFCC_API}${VUE_APP_API_GALLERY}?rand=${no_cache}`)
        if(res){
            return res.data.records
        }else{
            return []
        }
};

const postEmail = async(data) => {
    try{
        const res = await axios
        .post(`${VUE_APP_API}${VUE_APP_API_EMAIL}`, data)
       if(res){
        return true
       }
       else return false
    }catch(e){
            console.error('Error: ' + e);
            return false
    }
};

export {
    fetchBanners,
    fetchCoaches,
    fetchCommitteeMembers,
    fetchFixtures,
    fetchNews,
    fetchNewsByID,
    fetchPlayers,
    fetchTraining,
    fetchEvents,
    fetchGallery,
    postEmail
};
